import { render, staticRenderFns } from "./objectiveReviewRep.vue?vue&type=template&id=6d920d62&"
import script from "./objectiveReviewRep.vue?vue&type=script&lang=js&"
export * from "./objectiveReviewRep.vue?vue&type=script&lang=js&"
import style0 from "./objectiveReviewRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports